import PowersearchCompanyDescriptionValueEditor from "./PowersearchCompanyDescriptionValueEditor";
import PowersearchIndustryValueEditor from "./PowersearchIndustryValueEditor";
import PowersearchJobTitleValueEditor from "./PowersearchJobTitleValueEditor";
import PowersearchLinkedinProfileKeywordValueEditor from "./PowersearchLinkedinProfileKeywordValueEditor";
import PowersearchCityValueEditor from "./PowersearchCityValueEditor";
import PowersearchStateValueEditor from "./PowersearchStateValueEditor";
import PowersearchCountryValueEditor from "./PowersearchCountryValueEditor";
import PowersearchTextInputEditor from "./PowersearchTextInputEditor";
import { PowersearchFieldEnum } from "../PowersearchQueryRule";

export interface IPowersearchFieldValueProps {
  operator: string;
  value: any;
  handleOnChange: (value: any) => void;
  disabled?: boolean;
  field: PowersearchFieldEnum;
  errorMessage?: string;
}

const PowersearchFieldValue = (props: IPowersearchFieldValueProps) => {
  if (props.field === PowersearchFieldEnum.CompanyIndustry) {
    return <PowersearchIndustryValueEditor {...props} />;
  }
  if (props.field === PowersearchFieldEnum.JobTitle) {
    return <PowersearchJobTitleValueEditor {...props} />;
  }
  if (props.field === PowersearchFieldEnum.CompanyDescription) {
    return <PowersearchCompanyDescriptionValueEditor {...props} />;
  }
  if (props.field === PowersearchFieldEnum.LinkedInProfileKeywords) {
    return <PowersearchLinkedinProfileKeywordValueEditor {...props} />;
  }
  if (
    props.field === PowersearchFieldEnum.ContactCity ||
    props.field === PowersearchFieldEnum.CompanyCity
  ) {
    return <PowersearchCityValueEditor {...props} />;
  }
  if (
    props.field === PowersearchFieldEnum.ContactState ||
    props.field === PowersearchFieldEnum.CompanyState
  ) {
    return <PowersearchStateValueEditor {...props} />;
  }
  if (
    props.field === PowersearchFieldEnum.ContactCountry ||
    props.field === PowersearchFieldEnum.CompanyCountryIso
  ) {
    return <PowersearchCountryValueEditor {...props} />;
  }
  if (props.field === PowersearchFieldEnum.CompanyHeadCountRange) {
    return <PowersearchTextInputEditor {...props} type="number" />;
  }

  // fallback to default ValueEditor
  return <div></div>;
};

export default PowersearchFieldValue;
